import React from "react";


export default () => {

    return (
        <div style={{ width: '90%', height: '200px', textAlign: 'center',backgroundColor:'#ffffff',  paddingTop: '11px', fontFamily: 'Roboto', fontSize: '11px', paddingLeft: '30px', textAlign: 'left', color: '#222222' }}>
            <div style={{ minWidth: '300px', textAlign: 'center', lineHeight:'1.3',fontFamily:'Noto sans', fontSize:'11px', textAlign:'left',paddingLeft:'30px',paddingTop:'30px' }}>
            NSTRUCT Inc. &nbsp;&nbsp;<br />
            All rights reserved&copy;
            </div>
        </div>
    );

}
